import { render, staticRenderFns } from "./TheoryList.vue?vue&type=template&id=44f139b8&scoped=true"
import script from "./TheoryList.vue?vue&type=script&lang=js"
export * from "./TheoryList.vue?vue&type=script&lang=js"
import style0 from "./TheoryList.vue?vue&type=style&index=0&id=44f139b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f139b8",
  null
  
)

export default component.exports